export const MORE_INFO_SECTION_SLUGS = {
  terms: "terms_and_conditions",
  privacy: "privacy_policy",
  about: "about_us",
  faq: "faq",
};

export const buildTextPagePayload = ({ title, content }) => ({
  title: title?.trim() ?? "",
  content: content?.trim() ?? "",
});

export const buildAboutPayload = ({ title, description }) => ({
  title: title?.trim() ?? "",
  content: description?.trim() ?? "",
});

export const buildFaqPayload = (items) =>
  items.map((item, index) => ({
    question: item.question?.trim() ?? "",
    answer: item.answer?.trim() ?? "",
    displayOrder: index + 1,
  }));
